export default __webpack_public_path__ + "static/media/upright-tips.140d11ff.png";